export function countDecimalPlaces(num: number): number {
  const numString = num.toString()

  const dotIndex = numString.indexOf('.')

  if (dotIndex === -1) {
    return 0
  }

  return numString.length - dotIndex - 1
}

export function countDecimalPlacesBigNumber(num: string): number {
  const dotIndex = num.indexOf('.')

  if (dotIndex === -1) return 0

  return num.length - dotIndex - 1
}